export default "__VITE_ASSET__DZAZx3P7__"